import { Download, Handshake } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { scrollTo } from "@/lib/lenis";
import { API } from "@/lib/api";
import { SPONSOR_TIERS, SPONSOR_PARTNERS } from "@/lib/site";

export default function Sponsors() {
  return (
    <section id="sponsors" className="py-28 lg:py-36" data-testid="sponsors-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionHeading
          eyebrow="Sponsorship"
          title={<>PARTNER WITH <span className="gold-text">HA TREASURE HOUSE</span></>}
          sub="Associate your brand with talent, glamour, fashion, entertainment, and premium experiences."
          testId="sponsors-heading"
        />

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-testid="sponsor-tiers">
          {SPONSOR_TIERS.map((t, i) => (
            <Reveal key={t.name} delay={0.08 * i}>
              <div
                className={`group h-full rounded-md p-8 flex flex-col transition-all duration-500 hover:-translate-y-1.5 ${i === 0 ? "bg-gradient-to-b from-gold/15 to-transparent border border-gold/50 shadow-[0_0_40px_rgba(212,175,55,0.12)]" : "glass-card hover:border-gold/40"}`}
                data-testid={`sponsor-tier-${i}`}
              >
                <span className="text-[10px] tracking-[0.3em] uppercase text-fuchsia font-semibold">{t.tag}</span>
                <h3 className="mt-3 font-display text-2xl gold-text font-semibold">{t.name}</h3>
                <p className="mt-4 text-sm text-muted leading-relaxed flex-1">{t.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-8 flex flex-wrap justify-center gap-3" data-testid="sponsor-partners">
          {SPONSOR_PARTNERS.map((p) => (
            <span key={p} className="rounded-full border border-gold/25 px-5 py-2 text-xs tracking-widest uppercase text-cream/75">
              {p}
            </span>
          ))}
        </Reveal>

        <Reveal className="mt-14 flex flex-wrap justify-center gap-4">
          <button
            onClick={() => scrollTo("#contact")}
            className="inline-flex items-center gap-2 rounded-full bg-gold text-royal-950 px-9 py-4 text-sm font-semibold tracking-widest transition-all duration-300 hover:bg-gold-light hover:shadow-[0_0_35px_rgba(212,175,55,0.5)]"
            data-testid="become-sponsor-cta"
          >
            <Handshake size={18} /> BECOME A SPONSOR
          </button>
          <a
            href={`${API}/sponsorship-proposal`}
            download
            className="inline-flex items-center gap-2 rounded-full border border-gold/50 px-9 py-4 text-sm font-semibold tracking-widest text-gold transition-all duration-300 hover:bg-gold/10 hover:border-gold"
            data-testid="download-proposal-cta"
          >
            <Download size={18} /> DOWNLOAD PROPOSAL
          </a>
        </Reveal>
      </div>
    </section>
  );
}
